<template>
    <label :style="style">
        <div class="checkbox-container">
            <input type="checkbox" v-model="isChecked" />
            <span class="checkmark"></span>
        </div>
        <div class="text" v-if="text.length > 0" v-html="text" />
        <slot></slot>
    </label>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
    props: {
        value: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: ""
        },
        backgroundColor: {
            type: String,
            default: "var(--secondary)"
        },
        foregroundColor: {
            type: String,
            default: "var(--buttonTextColor)"
        }
    },
    emits: ["input"],
    setup(props, { emit }) {
        const isChecked = ref(props.value);

        watch(isChecked, () => {
            emit("input", isChecked.value);
        });

        watch(props, () => {
            if (props.value !== isChecked.value) {
                isChecked.value = props.value;
            }
        });

        const style = ref({
            "--background-color": props.backgroundColor,
            "--foreground-color": props.foregroundColor
        });

        return {
            isChecked,
            style
        };
    }
});
</script>
<style scoped>
label {
    /* margin: 15px 5vw; */
    display: flex;
    flex-direction: row;
    align-content: center;
    line-height: 25px;
    position: relative;
}

.text {
    text-align: left;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkbox-container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    user-select: none;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: var(--background-color);
    border-radius: 5px;
}

/* When the checkbox is checked, add a blue background */
/* .checkbox-container input:checked ~ .checkmark {
    background-color: var(--secondary);
} */

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid var(--foreground-color);
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
</style>
